import {Action} from "redux";
import {CreatePaymentInfoByClientBillingRequest, GetCompanyByClientBillingRequest} from "../request/company_request";
import {IClientBillingActionCreator} from "../action/client_billing_action";

interface IClientBillingDispatcher {
    getCompany(item: GetCompanyByClientBillingRequest): void;

    createPaymentInfo(item: CreatePaymentInfoByClientBillingRequest): void;
}

class Dispatcher implements IClientBillingDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientBillingActionCreator) {

    }

    public getCompany = (item: GetCompanyByClientBillingRequest): void => {
        this.dispatch(this.actionCreator.requestGetCompanyAction(item));
    }

    public createPaymentInfo = (item: CreatePaymentInfoByClientBillingRequest): void => {
        this.dispatch(this.actionCreator.requestCreatePaymentInfoAction(item));
    }

}

const createClientBillingDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientBillingActionCreator): IClientBillingDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientBillingDispatcher, createClientBillingDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_billing_dispatcher.ts